import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BookingHistoryList } from "@/services/bookinghistory.service";
import { useAuthStore } from "@/stores/auth.store";
import type { BookingHistoryData } from "@/types/booking-history/bookinghistory";

export function useBookingHistory() {
  const [loading, setLoading] = useState(true);
  const [bookingHistory, setBookingHistory] =
    useState<BookingHistoryData | null>(null);

  const fetchBookingHistory = async (
    searchKeyword = "",
    pageNo = 1,
  ) => {
    try {
      setLoading(true);

      const response = await BookingHistoryList({
        agentCompanySellerId:
          useAuthStore.getState().user?.agentCompanySellerId ?? "",
        searchKeyword,
        pageNo,
        pageSize: 5,
      });

      setBookingHistory(response.data);
    } catch (error) {
      toast.error(
        error instanceof Error
          ? error.message
          : "Failed to load booking history.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadBookingHistory = async () => {
      try {
        const response = await BookingHistoryList({
          agentCompanySellerId:
            useAuthStore.getState().user?.agentCompanySellerId ?? "",
          searchKeyword: "",
          pageNo: 1,
          pageSize: 5,
        });

        setBookingHistory(response.data);
      } catch (error) {
        toast.error(
          error instanceof Error
            ? error.message
            : "Failed to load booking history.",
        );
      } finally {
        setLoading(false);
      }
    };

    loadBookingHistory();
  }, []);

  return {
    loading,
    bookingHistory,
    fetchBookingHistory,
  };
}